import { render, staticRenderFns } from "./WrongContract.vue?vue&type=template&id=10ce5b8e&"
import script from "./WrongContract.vue?vue&type=script&lang=js&"
export * from "./WrongContract.vue?vue&type=script&lang=js&"
import style0 from "./WrongContract.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports